import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from '../_services/api.service';
import { OneUser, UserData } from '../_models/users';
import { NotificationService } from '../_services/notification.service';
import { UserDirectorData } from '../_models/UserDirector';
import { UserContactPerson, UserContactPersonData } from '../_models/UserContactPerson';
import { UserOwnerData } from '../_models/UserOwner';
import { UserLocalBranchData } from '../_models/UserLocalBranch';
import { UserInternationalBData } from '../_models/UserInternationalB';
import { UserRelatedEntityData } from '../_models/UserRelatedEntity';
import { UserBankAccountData } from '../_models/UserBankAccount';
import { UserDocumentTypeData } from '../_models/documentType';
import { phoneNumberValidator, shareholdingLimitValidator } from '../_services/validators';

declare var $: any;

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrl: './start.component.css'
})
export class StartComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  fragmentParam: string;

  error: boolean = false;
  errorMessage: string = "";
  
  publicKey: string;
  adminKey: string;
  token: string;
  loading: boolean = true;
  processing: boolean = false;

  buttonName: string = "Save and Continue";
  directorTitle: string = "Add New Director";
  directoeButtonTex: string = "Add New Director";
  contactTitle: string = "Add New Contact";
  contactButtonTex: string = "Add New Contact";
  ownerTitle: string = "Add New Owner";
  ownerButtonTex: string = "Add New Owner";
  localSubTitle: string = "Add New Branch";
  localSubButtonTex: string = "Add New Branch";
  intSubTitle: string = "Add New Branch";
  intSubButtonTex: string = "Add New Branch";
  relatedTitle: string = "Add New Entity";
  relatedButtonTex: string = "Add New Entity";
  bankTitle: string = "Add New Bank Account";
  bankButtonTex: string = "Add New Bank Account";
  uploadButton = "Upload File";
  uploadLabel: string = "";

  commentError: string = "One or more of the data submitted here has been rejected by the administrator";
  
  userName: string = '';
  userRef: number = 0;

  addShareHolder: number = 0;

  userData: UserData;

  companyDetails: boolean = true;
  directorDetails: boolean = false;
  contactPersonDetails: boolean = false;
  ownershipDetails: boolean = false;
  transactionDetails: boolean = false;
  complianceDetails: boolean = false;
  uploadFiles: boolean = false;

  fileToUpload: File = null;

  progressBarValue: number = 0;

  documentTypeArray: UserDocumentTypeData[] = [];
  defaultDocumentTypeArray: UserDocumentTypeData[] = [];

  companyDetailsComplete: boolean = false;
  directorDetailsComplete: boolean = false;
  ownershipDetailsComplete: boolean = false;
  contactPersonDetailsComplete: boolean = false;
  transactionDetailsComplete: boolean = false;
  complianceDetailsComplete: boolean = false;
  uploadFilesComplete: boolean = false;
  formComlete: boolean = false;

  today: string = new Date().toISOString().split('T')[0];

  uploadFilesForm = this.fb.group({
    userDocumentRef: ['', Validators.required],
    fileUpload: ['', Validators.required]
  });

  get userDocumentRef() { return this.uploadFilesForm.get('userDocumentRef'); }
  get fileUpload() { return this.uploadFilesForm.get('fileUpload'); }

  companyDetailsForm = this.fb.group({
    companyDetailsFormRef: [0],
    name: ['', Validators.required],
    address: ['', Validators.required],
    reg_no: ['', Validators.required],
    incoporation_date: ['', Validators.required],
    trade_name: [''],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, phoneNumberValidator()]],
    whatsapp: ['', [Validators.required, phoneNumberValidator()]],
    object: ['', Validators.required],
    purpose: ['', Validators.required],
    financial_year: ['', Validators.required],
    branche_affiliate: [''],
    license_body: [''],
    license_number: [''],
    regulator: ['']
  });
  
  get companyDetailsFormRef() { return this.companyDetailsForm.get('companyDetailsFormRef'); }
  get name() { return this.companyDetailsForm.get('name'); }
  get address() { return this.companyDetailsForm.get('address'); }
  get reg_no() { return this.companyDetailsForm.get('reg_no'); }
  get incoporation_date() { return this.companyDetailsForm.get('incoporation_date'); }
  get trade_name() { return this.companyDetailsForm.get('trade_name'); }
  get email() { return this.companyDetailsForm.get('email'); }
  get phone() { return this.companyDetailsForm.get('phone'); }
  get whatsapp() { return this.companyDetailsForm.get('whatsapp'); }
  get object() { return this.companyDetailsForm.get('object'); }
  get purpose() { return this.companyDetailsForm.get('purpose'); }
  get financial_year() { return this.companyDetailsForm.get('financial_year'); }
  get branche_affiliate() { return this.companyDetailsForm.get('branche_affiliate'); }
  get license_body() { return this.companyDetailsForm.get('license_body'); }
  get license_number() { return this.companyDetailsForm.get('license_number'); }
  get regulator() { return this.companyDetailsForm.get('regulator'); }

  bankAccountForm = this.fb.group({
    bank_ref: [0],
    bank_accountNumber: ['', Validators.required],
    bank_accountType: ['', Validators.required],
    bank_bankName: ['', Validators.required]
  });
  
  get bank_ref() { return this.bankAccountForm.get('bank_ref'); }
  get bank_accountNumber() { return this.bankAccountForm.get('bank_accountNumber'); }
  get bank_accountType() { return this.bankAccountForm.get('bank_accountType'); }
  get bank_bankName() { return this.bankAccountForm.get('bank_bankName'); }

  transactionDetailsForm = this.fb.group({
    transaction_ref: [0],
    transaction_origin: ['', Validators.required],
    transaction_volume: ['', Validators.required],
    transaction_annual_revenue: ['', Validators.required],
    transaction_purpose: ['', Validators.required],
    transaction_application: ['', Validators.required],
    transaction_is_licence: ['', Validators.required],
    transaction_licence_number: [{ value: '', disabled: true }, Validators.required],
    transaction_licence_authority: [{ value: '', disabled: true }, Validators.required]
  });
  
  get transaction_ref() { return this.transactionDetailsForm.get('transaction_ref'); }
  get transaction_volume() { return this.transactionDetailsForm.get('transaction_volume'); }
  get transaction_annual_revenue() { return this.transactionDetailsForm.get('transaction_annual_revenue'); }
  get transaction_origin() { return this.transactionDetailsForm.get('transaction_origin'); }
  get transaction_purpose() { return this.transactionDetailsForm.get('transaction_purpose'); }
  get transaction_application() { return this.transactionDetailsForm.get('transaction_application'); }
  get transaction_licence_authority() { return this.transactionDetailsForm.get('transaction_licence_authority'); }
  get transaction_licence_number() { return this.transactionDetailsForm.get('transaction_licence_number'); }
  get transaction_is_licence() { return this.transactionDetailsForm.get('transaction_is_licence'); }

  
  complianceDetailsForm = this.fb.group({
    compliance_ref: [0],
    compliance_policy_status: ['', Validators.required],
    compliance_policy_notes: [{ value: '', disabled: true }, Validators.required],
    compliance_aml_status: ['', Validators.required],
    compliance_aml_notes: [{ value: '', disabled: true }, Validators.required],
    compliance_dueDilligence_status: ['', Validators.required],
    compliance_dueDilligence_notes: [{ value: '', disabled: true }, Validators.required],
    compliance_dataPrivacy_status: ['', Validators.required],
    compliance_dataPrivacy_notes: [{ value: '', disabled: true }, Validators.required],
    compliance_dispute_status: ['', Validators.required],
    compliance_dispute_notes: [{ value: '', disabled: true }, Validators.required]
  });
  
  get compliance_ref() { return this.complianceDetailsForm.get('compliance_ref'); }
  get compliance_policy_status() { return this.complianceDetailsForm.get('compliance_policy_status'); }
  get compliance_policy_notes() { return this.complianceDetailsForm.get('compliance_policy_notes'); }
  get compliance_aml_status() { return this.complianceDetailsForm.get('compliance_aml_status'); }
  get compliance_aml_notes() { return this.complianceDetailsForm.get('compliance_aml_notes'); }
  get compliance_dueDilligence_status() { return this.complianceDetailsForm.get('compliance_dueDilligence_status'); }
  get compliance_dueDilligence_notes() { return this.complianceDetailsForm.get('compliance_dueDilligence_notes'); }
  get compliance_dataPrivacy_status() { return this.complianceDetailsForm.get('compliance_dataPrivacy_status'); }
  get compliance_dataPrivacy_notes() { return this.complianceDetailsForm.get('compliance_dataPrivacy_notes'); }
  get compliance_dispute_status() { return this.complianceDetailsForm.get('compliance_dispute_status'); }
  get compliance_dispute_notes() { return this.complianceDetailsForm.get('compliance_dispute_notes'); }

  directorDetailsForm = this.fb.group({
    director_ref: [0],
    director_name: ['', Validators.required],
    director_designation: ['', Validators.required],
    director_dob: ['', Validators.required],
    director_address: ['', Validators.required],
    director_appointment_date: ['', Validators.required],
    director_nationality: ['', Validators.required],
    director_email: ['', [Validators.required, Validators.email]],
    director_phone: ['', [Validators.required, phoneNumberValidator()]],
    director_identification: ['', Validators.required],
    director_bvn: ['', Validators.required],
  });


  get director_ref() { return this.directorDetailsForm.get('director_ref'); }
  get director_name() { return this.directorDetailsForm.get('director_name'); }
  get director_designation() { return this.directorDetailsForm.get('director_designation'); }
  get director_dob() { return this.directorDetailsForm.get('director_dob'); }
  get director_address() { return this.directorDetailsForm.get('director_address'); }
  get director_appointment_date() { return this.directorDetailsForm.get('director_appointment_date'); }
  get director_nationality() { return this.directorDetailsForm.get('director_nationality'); }
  get director_email() { return this.directorDetailsForm.get('director_email'); }
  get director_phone() { return this.directorDetailsForm.get('director_phone'); }
  get director_identification() { return this.directorDetailsForm.get('director_identification'); }
  get director_bvn() { return this.directorDetailsForm.get('director_bvn'); }

  contactPersonDetailsForm = this.fb.group({
    contact_ref: [0],
    contact_name: ['', Validators.required],
    contact_address: ['', Validators.required],
    contact_designation: ['', Validators.required],
    contact_nationality: ['', Validators.required],
    contact_email: ['', [Validators.required, Validators.email]],
    contact_phone: ['', [Validators.required, phoneNumberValidator()]],
    contact_whatsapp: ['', Validators.required]
  });

  get contact_ref() { return this.contactPersonDetailsForm.get('contact_ref'); }
  get contact_name() { return this.contactPersonDetailsForm.get('contact_name'); }
  get contact_address() { return this.contactPersonDetailsForm.get('contact_address'); }
  get contact_designation() { return this.contactPersonDetailsForm.get('contact_designation'); }
  get contact_nationality() { return this.contactPersonDetailsForm.get('contact_nationality'); }
  get contact_email() { return this.contactPersonDetailsForm.get('contact_email'); }
  get contact_phone() { return this.contactPersonDetailsForm.get('contact_phone'); }
  get contact_whatsapp() { return this.contactPersonDetailsForm.get('contact_whatsapp'); }

  ownershipDetailsFOrm = this.fb.group({
    owner_ref: [0],
    owner_name: ['', Validators.required],
    owner_shareholding: [0, Validators.required],    
    owner_politicallyExposed: [0, Validators.required]
  });

  get owner_ref() { return this.ownershipDetailsFOrm.get('owner_ref'); }
  get owner_name() { return this.ownershipDetailsFOrm.get('owner_name'); }
  get owner_shareholding() { return this.ownershipDetailsFOrm.get('owner_shareholding'); }
  get owner_politicallyExposed() { return this.ownershipDetailsFOrm.get('owner_politicallyExposed'); }

  localSubsidiaryDetailsForm = this.fb.group({
    local_ref: [0],
    local_name: ['', Validators.required],
    local_address: ['', Validators.required],
  });

  get local_ref() { return this.localSubsidiaryDetailsForm.get('local_ref'); }
  get local_name() { return this.localSubsidiaryDetailsForm.get('local_name'); }
  get local_address() { return this.localSubsidiaryDetailsForm.get('local_address'); }

  intSubsidiaryDetailsForm = this.fb.group({
    int_ref: [0],
    int_name: ['', Validators.required],
    int_address: ['', Validators.required],
    int_country: ['', Validators.required]
  });

  get int_ref() { return this.intSubsidiaryDetailsForm.get('int_ref'); }
  get int_name() { return this.intSubsidiaryDetailsForm.get('int_name'); }
  get int_address() { return this.intSubsidiaryDetailsForm.get('int_address'); }
  get int_country() { return this.intSubsidiaryDetailsForm.get('int_country'); }

  relatedEntityDetailsForm = this.fb.group({
    related_ref: [0],
    related_name: ['', Validators.required],
    related_nationality: ['', Validators.required],
    related_nature: ['', Validators.required],
    related_director_1: [0, Validators.required],
    related_director_2: [0, Validators.required]
  });

  get related_ref() { return this.relatedEntityDetailsForm.get('related_ref'); }
  get related_name() { return this.relatedEntityDetailsForm.get('related_name'); }
  get related_nationality() { return this.relatedEntityDetailsForm.get('related_nationality'); }
  get related_nature() { return this.relatedEntityDetailsForm.get('related_nature'); }
  get related_director_1() { return this.relatedEntityDetailsForm.get('related_director_1'); }
  get related_director_2() { return this.relatedEntityDetailsForm.get('related_director_2'); }
  
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.getRouteParams();
    this.userData = new UserData();
    this.checkToken();
  }

  ngOnInit(): void {
    if (this.routeParams['token'] !== undefined) {
      this.publicKey = this.routeParams['token'];
    }

    if (this.routeParams['publicKey'] !== undefined) {
      this.adminKey = this.routeParams['publicKey'];
    }

    // Subscribe to fragment changes
    if (this.fragmentParam !== undefined) {
      this.jump(this.fragmentParam);
    }

    this.ownershipDetailsFOrm.controls['owner_shareholding'].valueChanges.subscribe(change => {
      this.get100PerCent(change);
    });

    // Subscribe to value changes of the select control
    this.transactionDetailsForm.get('transaction_is_licence')?.valueChanges.subscribe((value) => {
      if (value === "1") {
        this.transactionDetailsForm.get('transaction_licence_authority')?.enable();
        this.transactionDetailsForm.get('transaction_licence_number')?.enable();
      } else {
        this.transactionDetailsForm.get('transaction_licence_authority')?.disable();
        this.transactionDetailsForm.get('transaction_licence_number')?.disable();
      }
    });


    // Subscribe to value changes of the select control
    this.complianceDetailsForm.get('compliance_policy_status')?.valueChanges.subscribe((value) => {
      if (value === "0") {
        this.complianceDetailsForm.get('compliance_policy_notes')?.enable();
        this.complianceDetailsForm.patchValue({
          compliance_policy_notes: this.userData.compliance.policy.notes
        })
      } else {
        this.complianceDetailsForm.get('compliance_policy_notes')?.disable();
        this.complianceDetailsForm.patchValue({
          compliance_policy_notes: ''
        })
      }
    });

    // Subscribe to value changes of the select control
    this.complianceDetailsForm.get('compliance_aml_status')?.valueChanges.subscribe((value) => {
      if (value === "0") {
        this.complianceDetailsForm.get('compliance_aml_notes')?.enable();
        this.complianceDetailsForm.patchValue({
          compliance_aml_notes: this.userData.compliance.aml.notes
        })
      } else {
        this.complianceDetailsForm.get('compliance_aml_notes')?.disable();
        this.complianceDetailsForm.patchValue({
          compliance_aml_notes: ''
        })
      }
    });

    // Subscribe to value changes of the select control
    this.complianceDetailsForm.get('compliance_dueDilligence_status')?.valueChanges.subscribe((value) => {
      if (value === "0") {
        this.complianceDetailsForm.get('compliance_dueDilligence_notes')?.enable();
        this.complianceDetailsForm.patchValue({
          compliance_dueDilligence_notes: this.userData.compliance.dueDilligence.notes
        })
      } else {
        this.complianceDetailsForm.get('compliance_dueDilligence_notes')?.disable();
        this.complianceDetailsForm.patchValue({
          compliance_dueDilligence_notes: ''
        })
      }
    });

    // Subscribe to value changes of the select control
    this.complianceDetailsForm.get('compliance_dataPrivacy_status')?.valueChanges.subscribe((value) => {
      if (value === "0") {
        this.complianceDetailsForm.get('compliance_dataPrivacy_notes')?.enable();
        this.complianceDetailsForm.patchValue({
          compliance_dataPrivacy_notes: this.userData.compliance.dataPrivacy.notes
        })
      } else {
        this.complianceDetailsForm.get('compliance_dataPrivacy_notes')?.disable();
        this.complianceDetailsForm.patchValue({
          compliance_dataPrivacy_notes: ''
        })
      }
    });

    // Subscribe to value changes of the select control
    this.complianceDetailsForm.get('compliance_dispute_status')?.valueChanges.subscribe((value) => {
      if (value === "1") {
        this.complianceDetailsForm.get('compliance_dispute_notes')?.enable();
        this.complianceDetailsForm.patchValue({
          compliance_dispute_notes: this.userData.compliance.dispute.notes
        })
      } else {
        this.complianceDetailsForm.get('compliance_dispute_notes')?.disable();
        this.complianceDetailsForm.patchValue({
          compliance_dispute_notes: ''
        })
      }
    });
  }

  get anyRejected(): boolean {
    const v = this.userData?.validation;
    return v?.ownershipDetails?.status?.rejected 
      || v?.internationalBDetails?.status?.rejected 
      || v?.relatedEntityDetails?.status?.rejected 
      || v?.localBranchDetails?.status?.rejected 
      || v?.bankAccountDetails?.status?.rejected;
  }


  // Updated method with a more specific typing for the event
  onOptionChange(event: EventTarget | null): void {
    const selectElement = event as HTMLSelectElement; // Type-safe cast
    const selectedOption = selectElement.selectedOptions[0];
    this.uploadLabel = selectedOption.getAttribute('data-notes') || '';
  }

  removeUploadIndex(customAttrToRemove: number): void {
    this.documentTypeArray = this.documentTypeArray.filter(option => option.userDocumentRef !== customAttrToRemove);
  }

  jump( tab: string = ''): void {
    if (tab == "companyDetails") {
      this.companyDetails = true;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "directorDetails") {
      this.companyDetails = false;
      this.directorDetails = true;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "contactPersonDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = true;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "ownershipDetails") {
      this.get100PerCent();
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = true;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "transactionDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = true;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "complianceDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = true;
      this.uploadFiles = false;
    } else if (tab == "uploadFiles") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = true;
    } else {
      this.companyDetails = true;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }
  }

  checkToken() {
    this.error = false;
    this.loading = true;
    this.apiService.checkToken(this.publicKey).subscribe(
      data => {
        if (data.success === true) {
          this.token = data.token.token;
          this.getDocumentType( this.token );
        } else {
            this.router.navigate(['/']);
        }
      }
    );
  }

  getDetails( token: string, jump = false) {
    this.apiService.getUserFromToken(token).subscribe(
      data => {
        if (data.success === true) {
          this.userData = data.data;

          if (jump) {
            this.jump();
          }

          this.userData.documents.forEach(element => {
            this.removeUploadIndex(element.ref);
          });

          if (this.isNotEmpty(this.userData.companyDetails)) {
            this.companyDetailsForm.patchValue({
              companyDetailsFormRef: this.userData.companyDetails.ref,
              name: this.userData.companyDetails.name,
              address: this.userData.companyDetails.address,
              reg_no: this.userData.companyDetails.regNo,
              incoporation_date: this.userData.companyDetails.incoporationDate,
              trade_name: this.userData.companyDetails.tradeName,
              email: this.userData.companyDetails.email,
              phone: this.userData.companyDetails.phone,
              whatsapp: this.userData.companyDetails.whatsapp,
              object: this.userData.companyDetails.object,
              purpose: this.userData.companyDetails.purpose,
              financial_year: this.userData.companyDetails.financialYear,
              branche_affiliate: this.userData.companyDetails.affiliate,
              license_body: this.userData.companyDetails.license.body,
              license_number: this.userData.companyDetails.license.number,
              regulator: this.userData.companyDetails.regulator
            });
          }

          if (this.isNotEmpty(this.userData.transaction)) {
            this.transactionDetailsForm.patchValue({
              transaction_ref: this.userData.transaction.ref,
              transaction_origin: this.userData.transaction.origin,
              transaction_annual_revenue: this.userData.transaction.annualRevenue,
              transaction_volume: this.userData.transaction.volume,
              transaction_purpose: this.userData.transaction.businessPurpose,
              transaction_application: this.userData.transaction.fundsApplication,
              transaction_is_licence: this.userData.transaction.license.required ? '1' : '0',
              transaction_licence_number: this.userData.transaction.license.issuer,
              transaction_licence_authority: this.userData.transaction.license.number
            });
          }

          if (this.isNotEmpty(this.userData.compliance)) {
            this.complianceDetailsForm.patchValue({
              compliance_ref: this.userData.compliance.ref,
              compliance_policy_status: this.userData.compliance.policy.status ? '1' : '0',
              compliance_policy_notes: this.userData.compliance.policy.notes,
              compliance_aml_status: this.userData.compliance.aml.status ? '1' : '0',
              compliance_aml_notes: this.userData.compliance.aml.notes,
              compliance_dueDilligence_status: this.userData.compliance.dueDilligence.status ? '1' : '0',
              compliance_dueDilligence_notes: this.userData.compliance.dueDilligence.notes,
              compliance_dataPrivacy_status: this.userData.compliance.dataPrivacy.status ? '1' : '0',
              compliance_dataPrivacy_notes: this.userData.compliance.dataPrivacy.notes,
              compliance_dispute_status: this.userData.compliance.dispute.status ? '1' : '0',
              compliance_dispute_notes: this.userData.compliance.dispute.notes
            });
          }

          this.get100PerCent();
          this.progressBar();
          this.getComplete();

          this.loading = false;
        } else {
          this.router.navigate(['/']);
        }
      }
    );
  }

  getComplete(): void {
    let userData = this.userData;

    if (userData.directorDetails.length > 0) {
      this.directorDetailsComplete = true;
    } else {
      this.directorDetailsComplete = false;
    }

    if (userData.companyDetails.ref != 0) {
      this.companyDetailsComplete = true;
    } else {
      this.companyDetailsComplete = false;
    }

    if (userData.contactPersons.length > 0) {
      this.contactPersonDetailsComplete = true;
    } else {
      this.contactPersonDetailsComplete = false;
    }

    if ((this.addShareHolder == 100 && (userData.bankAccounts.length > 0))) {
      this.ownershipDetailsComplete = true;
    } else {
      this.ownershipDetailsComplete = false;
    }

    if (userData.transaction.ref != 0) {
      this.transactionDetailsComplete = true;
    } else {
      this.transactionDetailsComplete = false;
    }

    if (userData.compliance.ref != 0) {
      this.complianceDetailsComplete = true;
    } else {
      this.complianceDetailsComplete = false;
    }

    if (userData.documents.length < this.documentDetails_total) {
      this.uploadFilesComplete = false;
    } else {
      this.uploadFilesComplete = true;
    }

    if (this.uploadFilesComplete && 
      this.complianceDetailsComplete && 
      this.transactionDetailsComplete && 
      this.ownershipDetailsComplete && 
      this.contactPersonDetailsComplete && 
      this.companyDetailsComplete && 
      this.directorDetailsComplete &&
      !this.userData.validation.companyDetails.status.rejected &&
      !this.userData.validation.directorDetails.status.rejected &&
      !this.userData.validation.contactPersonDetails.status.rejected &&
      !this.userData.validation.ownershipDetails.status.rejected &&
      !this.userData.validation.relatedEntityDetails.status.rejected &&
      !this.userData.validation.localBranchDetails.status.rejected &&
      !this.userData.validation.internationalBDetails.status.rejected &&
      !this.userData.validation.bankAccountDetails.status.rejected &&
      !this.userData.validation.transactionDetails.status.rejected &&
      !this.userData.validation.complianceDetails.status.rejected &&
      !this.userData.validation.uploadFiles.status.rejected
    ) {
      this.formComlete = true;
    } else {
      this.formComlete = false;
    }
  }

  async getDocumentType(token: string, jump:boolean = false) {
    try {
      const documentType = await this.apiService.getDocumentType(token);
      this.documentTypeArray = documentType.data;
      this.defaultDocumentTypeArray = documentType.data;

      this.userData.documents.forEach(element => {
        this.removeUploadIndex(element.ref);
      });

      this.getDetails( token, jump );
    } catch (error) {
      console.error('Error fetching document type:', error);
    }
  }

  async getAdminData() {
    // try {
    //   const adminData = await this.apiService.getDocumentType(token);
    //   this.documentTypeArray = documentType.data;
    //   this.defaultDocumentTypeArray = documentType.data;
    // } catch (error) {
    //   console.error('Error fetching document type:', error);
    // }
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // Don't subscribe to queryParams for fragment
    // Instead, handle fragment in ngOnInit or here:
    this.activatedRoute.fragment.subscribe(fragment => {
      this.fragmentParam = fragment;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  buttonAction(action: string) {
    if (action == 'companyDetailsForm') {
      this.companyDetailsFormSave();
    } else if (action == 'companyDetailsBack') {
      this.companyDetails = true;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (action == 'directorDetailsForm') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = true;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'directorDetailsBack') {
      this.companyDetails = false
      this.directorDetails = true;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'contactPersonDetailsForm') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = true;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'ownershipDetailsBack') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = true;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'ownershipDetailsForm') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = true;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'transactionDetailsBack') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = true;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'transactionDetailsForm') {
      this.transactionDetailsFormSave()
    } else if (action == 'complianceDetailsBack') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = true;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }  else if (action == 'complianceDetailsForm') {
      this.complianceDetailsFormSave()
    } else if (action == 'uploadFilesBack') {
      this.companyDetails = false
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = true;
      this.uploadFiles = false;
    }  else if (action == 'uploadFilesForm') {
      this.complianceDetailsFormSave()
    }
  }

  complianceDetailsFormSave() {
    var data: object = {
      havePolicy: this.complianceDetailsForm.value.compliance_policy_status,
      noPolicyExplanation: (this.complianceDetailsForm.value.compliance_policy_status == "1") ? '' : this.complianceDetailsForm.value.compliance_policy_notes,

      amlChecks: this.complianceDetailsForm.value.compliance_aml_status,
      noAmlExplanation: (this.complianceDetailsForm.value.compliance_aml_status == "1") ? '' : this.complianceDetailsForm.value.compliance_aml_notes,

      dueDiligencCheck: this.complianceDetailsForm.value.compliance_dueDilligence_status,
      noDueDiligencCheckExplanation: (this.complianceDetailsForm.value.compliance_dueDilligence_status == "1") ? '' : this.complianceDetailsForm.value.compliance_dueDilligence_notes,

      dataPrivaacyPolicy: this.complianceDetailsForm.value.compliance_dataPrivacy_status,
      noDataPrivaacyPolicyExplanation: (this.complianceDetailsForm.value.compliance_dataPrivacy_status == "1") ? '' : this.complianceDetailsForm.value.compliance_dataPrivacy_notes,

      dispute: this.complianceDetailsForm.value.compliance_dispute_status,
      yesDisputeExplanation: (this.complianceDetailsForm.value.compliance_dispute_status == "0") ? '' : this.complianceDetailsForm.value.compliance_dispute_notes
    };

    if (this.complianceDetailsForm.value.compliance_ref > 0) {
      data['ref'] = this.complianceDetailsForm.value.compliance_ref ;
    }

    this.complianceDetailsFormCreate(data);
  }

  complianceDetailsFormCreate( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.complianceDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Updated Compliance Details", "Compliance Details Created");
          this.userData.compliance = user.data;
          this.ngOnInit();

          this.getDocumentType( this.token, true );
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = true;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  transactionDetailsFormSave() {
    var data: object = {
      origin: this.transactionDetailsForm.value.transaction_origin,
      revenue: this.transactionDetailsForm.value.transaction_annual_revenue,
      volume: this.transactionDetailsForm.value.transaction_volume,
      businessPurpose: this.transactionDetailsForm.value.transaction_purpose,
      fundsApplication: this.transactionDetailsForm.value.transaction_application,
      licenseAuth: (this.transactionDetailsForm.value.transaction_is_licence == "0") ? '' : this.transactionDetailsForm.value.transaction_licence_authority,
      licenseNumber: (this.transactionDetailsForm.value.transaction_is_licence == "0") ? '' : this.transactionDetailsForm.value.transaction_licence_number,
      requireLicense: this.transactionDetailsForm.value.transaction_is_licence
    };

    if (this.transactionDetailsForm.value.transaction_ref > 0) {
      data['ref'] = this.transactionDetailsForm.value.transaction_ref ;
    }

    this.transactionDetailsFormCreate(data);
  }

  transactionDetailsFormCreate( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.transactionDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Updated Transaction Details", "Transaction Details Created");
          this.userData.transaction = user.data;
          this.ngOnInit();

          this.getDocumentType( this.token );
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = true;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  companyDetailsFormSave() {
    var data: object = {
      name: this.companyDetailsForm.value.name,
      address: this.companyDetailsForm.value.address,
      reg_no: this.companyDetailsForm.value.reg_no,
      incoporation_date: this.companyDetailsForm.value.incoporation_date,
      trade_name: this.companyDetailsForm.value.trade_name,
      email: this.companyDetailsForm.value.email,
      phone: this.companyDetailsForm.value.phone,
      whatsapp: this.companyDetailsForm.value.whatsapp,
      object: this.companyDetailsForm.value.object,
      purpose: this.companyDetailsForm.value.purpose,
      financial_year: this.companyDetailsForm.value.financial_year,
      branche_affiliate: this.companyDetailsForm.value.branche_affiliate,
      license_body: this.companyDetailsForm.value.license_body,
      license_number: this.companyDetailsForm.value.license_number,
      regulator: this.companyDetailsForm.value.regulator
    };

    if (this.companyDetailsForm.value.companyDetailsFormRef > 0) {
      data['ref'] = this.companyDetailsForm.value.companyDetailsFormRef ;
    }

    this.companyDetailsFormCreate(data);
  }

  companyDetailsFormCreate( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.companyDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Created "+data.name+" as an Administrator", "Administrator Created");
          this.userData.companyDetails = user.data;
          this.ngOnInit();

          this.getDocumentType( this.token );
          this.companyDetails = false;
          this.directorDetails = true;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.companyDetailsForm.reset();

        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  resetforms() {
    
  }

  getEditDirector(data: UserDirectorData) {
    this.directorDetailsForm.patchValue({
      director_ref: data.ref,
      director_name: data.name,
      director_designation: data.designation,
      director_dob: data.dob,
      director_address: data.address,
      director_appointment_date: data.appointmentDate,
      director_nationality	: data.nationality,
      director_email: data.email,
      director_phone: data.phone,
      director_identification: data.identification,
      director_bvn: data.bvn
    });

    this.directorTitle = "Edit " + data.name;
  }

  onCancel() {
    this.directorDetailsForm.reset();
    this.contactPersonDetailsForm.reset();
    this.companyDetailsForm.reset();
    this.ownershipDetailsFOrm.reset();
    this.intSubsidiaryDetailsForm.reset();
    this.relatedEntityDetailsForm.reset();
    this.localSubsidiaryDetailsForm.reset();
    this.bankAccountForm.reset();
    this.clearModal();
    this.directorTitle = this.directoeButtonTex = "Add New Director";
  }

  onCreateDirector() {
    var data: object = {
      name: this.directorDetailsForm.value.director_name,
      designation: this.directorDetailsForm.value.director_designation,
      dob: this.directorDetailsForm.value.director_dob,
      address: this.directorDetailsForm.value.director_address,
      appointment_date: this.directorDetailsForm.value.director_appointment_date,
      nationality	: this.directorDetailsForm.value.director_nationality,
      email: this.directorDetailsForm.value.director_email,
      phone: this.directorDetailsForm.value.director_phone,
      identification: this.directorDetailsForm.value.director_identification,
      bvn: this.directorDetailsForm.value.director_bvn
    };

    if (this.directorDetailsForm.value.director_ref > 0) {
      data['ref'] = this.directorDetailsForm.value.director_ref ;
    }
    this.createDirector( data );
  }

  createDirector( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.directorDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as an director", "Principal Officer");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = true;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.directorDetailsForm.reset();
          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  deleteDirector( ref: number ) {
    this.processing = true;

    this.apiService.directorDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Director Removed Successfully", "Principal Officer");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = true;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.clearModal();
      }
    );
  }
  

  companyDetails_total: number = 9;
  principalDetails_total: number = 1;
  ownershipDetails_total: number = 1;
  contactDetails_total: number = 1;
  calculateCompliance_total: number = 5;
  documentDetails_total: number = 1;
  bankAccountDetails_total: number = 1;
  transactionDetails_total: number = 3;

  progressBar() {
    this.documentDetails_total = this.defaultDocumentTypeArray.length;
    let companyDetails = 0;
    let principalDetails = 0;
    let contactDetails = 0;
    let ownershipDetails = 0;
    let transactionDetails = 0;
    let complianceDetails = 0;
    let documentDetails = 0;
    let bankAccountDetails = 0;


    companyDetails = (this.isNotEmpty(this.userData.companyDetails)) ?  this.calculateCompany() : 0;
    principalDetails = (this.userData.directorDetails.length > 0) ? 1:0;
    ownershipDetails = (this.userData.ownership.length > 0) ? 1:0;
    contactDetails = (this.userData.contactPersons.length > 0) ? 1:0;
    complianceDetails = (this.isNotEmpty(this.userData.compliance)) ?  this.calculateCompliance() : 0;
    transactionDetails = (this.isNotEmpty(this.userData.transaction)) ?  this.calculateTransaction() : 0;
    documentDetails = this.userData.documents.length;
    bankAccountDetails = (this.userData.bankAccounts.length > 0) ? 1:0;

    this.progressBarValue = Math.round(((companyDetails + principalDetails + contactDetails + ownershipDetails + transactionDetails + complianceDetails + documentDetails + bankAccountDetails ) / (this.companyDetails_total + this.principalDetails_total + this.ownershipDetails_total + this.contactDetails_total + this.calculateCompliance_total + this.documentDetails_total + this.bankAccountDetails_total + this.transactionDetails_total )) * 100);
  }

  calculateCompany() {
    let company = this.userData.companyDetails
    let validate_name = (company.name != "") ? 1 : 0;
    let validate_address = (company.address != "") ? 1 : 0;
    let validate_regNo = (company.regNo != "") ? 1 : 0;
    let validate_whatsapp = (company.whatsapp != "") ? 1 : 0;
    let validate_email = (company.email != "") ? 1 : 0;
    let validate_phone = (company.phone != "") ? 1 : 0;
    let validate_object = (company.object != "") ? 1 : 0;
    let validate_purpose = (company.purpose != "") ? 1 : 0;
    let validate_financial_year = (company.financialYear != "") ? 1 : 0;

    return validate_name + validate_address + validate_regNo + validate_whatsapp + validate_email + validate_phone + validate_object + validate_purpose + validate_financial_year;
  }

  calculateCompliance() {
    let compliance = this.userData.compliance;

    let validate_policy = (compliance.policy !== undefined) ? 1 : 0;
    let validate_aml = (compliance.aml !== undefined) ? 1 : 0;
    let validate_dueDilligence = (compliance.dueDilligence !== undefined) ? 1 : 0;
    let validate_dataPrivacy = (compliance.dataPrivacy !== undefined) ? 1 : 0;
    let validate_dispute = (compliance.dispute !== undefined) ? 1 : 0;

    return validate_policy + validate_aml + validate_dueDilligence + validate_dataPrivacy + validate_dispute;
  }

  calculateTransaction() {
    let transaction = this.userData.transaction

    let validate_origin = (transaction.origin != "") ? 1 : 0;
    let validate_businessPurpose = (transaction.businessPurpose != "") ? 1 : 0;
    let validate_fundsApplication = (transaction.fundsApplication != "") ? 1 : 0;

    return validate_origin + validate_businessPurpose + validate_fundsApplication;
  }

  getDataFromList(name:string, ref:number) {
    this.userName = name;
    this.userRef = ref;
  }

  getEditContact(data: UserContactPersonData) {
    this.contactPersonDetailsForm.patchValue({
      contact_ref: data.ref,
      contact_name: data.name,
      contact_designation: data.designation,
      contact_address: data.address,
      contact_nationality: data.nationality,
      contact_email: data.email,
      contact_phone: data.phone,
      contact_whatsapp: data.whatsapp
    });

    this.directorTitle = "Edit " + data.name;
  }

  onCreateContact() {
    var data: object = {
      name: this.contactPersonDetailsForm.value.contact_name,
      designation: this.contactPersonDetailsForm.value.contact_designation,
      address: this.contactPersonDetailsForm.value.contact_address,
      nationality	: this.contactPersonDetailsForm.value.contact_nationality,
      email: this.contactPersonDetailsForm.value.contact_email,
      phone: this.contactPersonDetailsForm.value.contact_phone,
      whatsapp: this.contactPersonDetailsForm.value.contact_whatsapp,
    };

    if (this.contactPersonDetailsForm.value.contact_ref > 0) {
      data['ref'] = this.contactPersonDetailsForm.value.contact_ref ;
    }
    this.createContact( data );
  }

  createContact( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.contactDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as a contact", "Contact Details");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = true;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.contactPersonDetailsForm.reset();
          
          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  deleteContact( ref: number ) {
    this.processing = true;

    this.apiService.contactDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Contact Removed Successfully", "Contact Details");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = true;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        
        this.clearModal();
      }
    );
  }

  getEditOwner(data: UserOwnerData) {
    this.ownershipDetailsFOrm.patchValue({
      owner_ref: data.ref,
      owner_name: data.name,
      owner_shareholding: data.shareholding,
      owner_politicallyExposed: Number(data.politicallyExposed)
    });

    this.ownerTitle = "Edit " + data.name;
  }

  getEditLocal(data: UserLocalBranchData) {
    this.localSubsidiaryDetailsForm.patchValue({
      local_ref: data.ref,
      local_name: data.name,
      local_address: data.address
    });

    this.directorTitle = "Edit " + data.name;
  }

  getEditIntl(data: UserInternationalBData) {
    this.intSubsidiaryDetailsForm.patchValue({
      int_ref: data.ref,
      int_name: data.name,
      int_address: data.address,
      int_country: data.country
    });

    this.directorTitle = "Edit " + data.name;
  }

  getEditRelated(data: UserRelatedEntityData) {
    this.relatedEntityDetailsForm.patchValue({
      related_ref: data.ref,
      related_name: data.name,
      related_nationality: data.nationality,
      related_nature: data.nature,
      related_director_1: data.director[0].ref,
      related_director_2: data.director[0].ref,
    });

    this.directorTitle = "Edit " + data.name;
  }

  getEditBankAccount(data: UserBankAccountData) {
    this.bankAccountForm.patchValue({
      bank_ref: data.ref,
      bank_accountNumber: data.accountNumber,
      bank_accountType: data.accountType,
      bank_bankName: data.bankName
    });

    this.directorTitle = "Edit " + data.accountNumber;
  }

  onCreateOwner() {
    var data: object = {
      name: this.ownershipDetailsFOrm.value.owner_name,
      shareholding: this.ownershipDetailsFOrm.value.owner_shareholding,
      politicallyExposed: this.ownershipDetailsFOrm.value.owner_politicallyExposed
    };

    if (this.ownershipDetailsFOrm.value.owner_ref > 0) {
      data['ref'] = this.ownershipDetailsFOrm.value.owner_ref ;
    }
    this.createOwner( data );
  }

  createOwner( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.ownerDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as an owner", "Shareholding and Ownership");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.ownershipDetailsFOrm.reset();

          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  onCreateBank() {
    var data: object = {
      accountNumber: this.bankAccountForm.value.bank_accountNumber,
      accountType: this.bankAccountForm.value.bank_accountType,
      bankName: this.bankAccountForm.value.bank_bankName
    };

    if (this.bankAccountForm.value.bank_ref > 0) {
      data['ref'] = this.bankAccountForm.value.bank_ref ;
    }
    this.createBank( data );
  }

  createBank( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.bankAccountDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.accountNumber+" as a bank account number entity", "Bank Account");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.bankAccountForm.reset();

          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  onCreateRelated() {
    var data: object = {
      name: this.relatedEntityDetailsForm.value.related_name,
      nature: this.relatedEntityDetailsForm.value.related_nature,
      nationality: this.relatedEntityDetailsForm.value.related_nationality,
      director_2: this.relatedEntityDetailsForm.value.related_director_2,
      director_1: this.relatedEntityDetailsForm.value.related_director_1
    };

    if (this.relatedEntityDetailsForm.value.related_ref > 0) {
      data['ref'] = this.relatedEntityDetailsForm.value.related_ref ;
    }
    this.createRelated( data );
  }

  createRelated( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.relativeDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as a related entity", "Related Entity");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.relatedEntityDetailsForm.reset();
          
          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  onCreateInt() {
    var data: object = {
      name: this.intSubsidiaryDetailsForm.value.int_name,
      address: this.intSubsidiaryDetailsForm.value.int_address,
      country: this.intSubsidiaryDetailsForm.value.int_country
    };

    if (this.intSubsidiaryDetailsForm.value.int_ref > 0) {
      data['ref'] = this.intSubsidiaryDetailsForm.value.int_ref ;
    }
    this.createInt( data );
  }

  createInt( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.intDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as an local subsidiary", "Local Subsidiaries");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
          this.intSubsidiaryDetailsForm.reset();

          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  onCreateLocal() {
    var data: object = {
      name: this.localSubsidiaryDetailsForm.value.local_name,
      address: this.localSubsidiaryDetailsForm.value.local_address,
    };

    if (this.localSubsidiaryDetailsForm.value.local_ref > 0) {
      data['ref'] = this.localSubsidiaryDetailsForm.value.local_ref ;
    }
    this.createLocal( data );
  }

  createLocal( data ) {
    this.processing = true;
    this.buttonName = "Saving...";

    this.apiService.localDetailsCreate(data, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Added "+data.name+" as an local subsidiary", "Local Subsidiaries");
          this.getDocumentType(this.token);
          this.localSubsidiaryDetailsForm.reset();
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;

          this.clearModal();
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.buttonName = "Save and Continue";
      }
    );
  }

  deleteOwner( ref: number ) {
    this.processing = true;

    this.apiService.ownerDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Owner Removed Successfully", "Shareholding and Ownership");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }

        this.clearModal();
      }
    );
  }

  deleteRelativeEntity( ref: number ) {
    this.processing = true;

    this.apiService.relativeDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Relatived Entity Removed Successfully", "Related Party/Entity");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.clearModal();
      }
    );
  }

  deleteBankAccount( ref: number ) {
    this.processing = true;

    this.apiService.bankAccountRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Account number Removed Successfully", "Bank Account");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.clearModal();
      }
    );
  }

  deleteFile( ref: number ) {
    this.processing = true;

    this.apiService.fileRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.documentTypeArray = this.defaultDocumentTypeArray;
          this.notifyService.showSuccess("Uploaded file Removed Successfully", "Upload Document");
          this.getDocumentType(this.token);

          this.getDetails(this.token, false);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = false;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = true;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.clearModal();
      }
    );
  }

  deleteInt( ref: number ) {
    this.processing = true;

    this.apiService.intDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("Int subsidiary Removed Successfully", "Int Subsidiaries");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }
        this.clearModal();
      }
    );
  }

  deleteLocal( ref: number ) {
    this.processing = true;

    this.apiService.localDetailsCRemove(ref, this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("local subsidiary Removed Successfully", "Local Subsidiaries");
          this.getDocumentType(this.token);
          this.companyDetails = false;
          this.directorDetails = false;
          this.contactPersonDetails = false;
          this.ownershipDetails = true;
          this.transactionDetails = false;
          this.complianceDetails = false;
          this.uploadFiles = false;
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }

        this.clearModal();
      }
    );
  }

  get100PerCent( value:number = 0) {
    let shareholding = value;
    let focus = this.owner_ref.value;
    
    this.userData.ownership.forEach(element => {
      if (element.ref != focus) {
        shareholding = shareholding + element.shareholding
      }
    });

    this.addShareHolder = shareholding;
    if (this.addShareHolder > 100) {
      this.owner_shareholding.setErrors({ exceedLimit: true });
      this.owner_shareholding.markAsTouched();
      this.owner_shareholding.markAsDirty();
    } else {
      // If no errors, remove exceedLimit error
      const errors = this.owner_shareholding.errors;
      if (errors) {
        delete errors.exceedLimit;
        if (Object.keys(errors).length === 0) {
          this.owner_shareholding.setErrors(null);
        } else {
          this.owner_shareholding.setErrors(errors);
        }
      }
    }
  }

  clearModal() {   
    $('#modal-add-director').modal('hide');
    $('#modal-delete-director').modal('hide');
    $('#modal-add-contact').modal('hide');
    $('#modal-delete-contact').modal('hide');
    $('#modal-add-owner').modal('hide');
    $('#modal-delete-owner').modal('hide');
    $('#modal-add-local').modal('hide');
    $('#modal-delete-local').modal('hide');
    $('#modal-add-intl').modal('hide');
    $('#modal-delete-intl').modal('hide');
    $('#modal-add-related').modal('hide');
    $('#modal-delete-related').modal('hide');
    $('#modal-add-bank').modal('hide');
    $('#modal-delete-bank').click()
    $('#modal-delete-document').modal('hide');
    $('#modal-submit-kyc').modal('hide');
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.fileToUpload = input.files[0];
    }
  }


  onUpload() {
    var data: object = {
      userDocumentRef: this.uploadFilesForm.value.userDocumentRef
    };

    this.upload( data );
  }

  upload(data) {
    this.processing = true;

    this.uploadButton = "Uploading...";
    this.apiService.uploadFile(data.userDocumentRef, this.fileToUpload, this.token).subscribe(
      upload => {
        if (upload.success == true) {
          this.notifyService.showSuccess("Uploaded new file to KYC record", "Upload Updated");
          this.getDetails(this.token, false);
        } else {
          this.notifyService.showError(upload.error.message, "Error")

        }
        this.uploadButton = "Upload File";
        this.processing = false
        this.uploadFilesForm.reset();
      }
    );
  }

  submitKyc() {
    this.processing = true;

    this.apiService.submitKyc(this.token).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.notifyService.showSuccess("KYC Forms completed successfully", "Complete");
          this.router.navigate(['/complete']); 
        } else {
          this.notifyService.showError(user.error.message, "Error")
        }

        this.clearModal();
      }
    );
  }

  isNotEmpty(obj: any): boolean {
    return Object.keys(obj).length > 0;
  }
  
  formatPhoneNumber(form: FormGroup, controlName: string): void {
    const input = form.get(controlName).value as string;
    const cleaned = input.replace(/\D+/g, ''); // Remove non-digit characters
    const match = cleaned.match(/^(\d{1,3})(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      form.get(controlName).setValue(
        `+${match[1]} (${match[2]}) ${match[3]} ${match[4]}`
      );
    }
  }

  findErrorRow(comment, name: string, id: number) {
    const match = comment.find(c => c.class.name === name && c.class.id === id);

    if (match) {
      return true
    } else {
      return false
    }
  }

  shareholdingValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const newValue = control.value;
      const ownerRef = this.owner_ref.value;
      let total = newValue;
  
      this.userData?.ownership?.forEach(element => {
        if (element.ref !== ownerRef) {
          total += element.shareholding;
        }
      });
  
      return total > 100 ? { shareholdingExceeded: true } : null;
    };
  };
}
